import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import { LightgalleryProvider } from "react-lightgallery";

import App from './App';
import api from './config/api.js';

class Root extends Component{

	/**
	 * Root component contructor
	 */
	constructor() {
		super();
		this.state={
			localeMessages: [],
			languages: [],
			selectedLanguage: {},
			defaultLanguage : {},
			geodata: null,
		};
	}

	/**
	 * Mount the component
	 */
	componentWillMount() {
		this.clearLocalStorage();
		this.loadLanguages();
		this.loadLocales();
	}

	/**
	 * Clear localStorage on first mount
	 */
	clearLocalStorage = () => {
		localStorage.clear();
	};

	/**
	 * Load all the available languages from the database
	 */
	loadLanguages = () => {
		fetch(api.language)
			.then(res => res.json())
			.then(data => {
				this.addLocalesToReactIntl(data);
				this.setState({languages: data});
				this.setDefaultLanguage();
				this.getClientIp();
			})
			.catch(err => console.error(err));
	};

	/**
	 * Load all the localized messages from the database
	 */
	loadLocales = () => {
		fetch(api.localeMessages)
			.then(res => res.json())
			.then(data => {
				this.setState({localeMessages: data});
			}).catch(err => console.error(err));
	};

	/**
	 * Get client Ip from API
	 */
	getClientIp = () => {
		fetch(api.geo)
			.then(res => res.json())
			.then(geodata => {
				this.setState({geodata});
				this.setSelectedLanguage();
			})
			.catch(err => console.error(err))
	};

	/**
	 * Change selected language
	 * @param language {Object} represents a language
	 */
	changeLanguage = (language) => {
		this.setState({selectedLanguage: language});
	};

	/**
	 * Set default language
	 */
	setDefaultLanguage = () => {
		const defaultLanguage = this.state.languages[0];
		this.setState({defaultLanguage});
	};

	/**
	 * Set selected language by url path
	 */
	setSelectedLanguage = () => {
		const path = window.location.pathname.split('/');
		const geodata = this.state.geodata;
		const defaultLanguage = this.state.languages[0];
		const geoLanguage = geodata === null || geodata === undefined
			? null
			: geodata.countryCode === null || geodata.countryCode === undefined
				? null
				: this.state.languages.find(lang => lang.codeCountry.includes(geodata.countryCode));

		if( geoLanguage !== null && geoLanguage !== undefined && path[1].length === 0 ){
			window.location.href = `/${geoLanguage.code}`;
		}

		this.changeLanguage(this.state.languages.find(lang => lang.code === path[1]) || defaultLanguage);
	};

	/**
	 * Add locales to react-intl dynamically
	 * @param languages
	 */
	addLocalesToReactIntl = (languages) => {
		languages.forEach(lang => addLocaleData(require(`react-intl/locale-data/${lang.code}`)))
	};
	
	render() {
		const {selectedLanguage,localeMessages,languages,defaultLanguage, geodata} = this.state;

		if(selectedLanguage.id === undefined || localeMessages.length === 0 || geodata === null){
			return null;
		}

		return (
			<IntlProvider locale={selectedLanguage.code}
			              messages={localeMessages[selectedLanguage.codeCountry]}>
				<LightgalleryProvider>
					<BrowserRouter>
						<Route render={ (props) => (
							<App
								availableLanguages={languages}
								selectedLanguage={selectedLanguage}
								defaultLanguage={defaultLanguage}
								changeLanguage={this.changeLanguage}
								{...props}
							/>
						)}/>
					</BrowserRouter>
				</LightgalleryProvider>
			</IntlProvider>
		);
	};
}

export default Root;


// WEBPACK FOOTER //
// ./src/Root.js